import { Grid, styled } from '@mui/material';

export const CommentsWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));
